import Vue from 'vue'
import { Skeleton, SkeletonTheme } from 'vue-loading-skeleton'

Vue.component('skeleton', Skeleton)
Vue.component('skeleton-theme', SkeletonTheme)
